import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MaterialService } from '../../../services/material.services';
import { MainService } from '../../../services/main.services';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { VersionImgViewerComponent } from '../../shared/version-img-viewer/version-img-viewer.component';

@Component({
  selector: 'app-material-compare',
  templateUrl: './material-compare.component.html',
  styleUrl: './material-compare.component.scss',
  providers: [DialogService]
})
export class MaterialCompareComponent {
  material_info: any;
  ref: DynamicDialogRef | undefined;
    constructor(private router: Router,
        private _params: ActivatedRoute,
                    private matService : MaterialService,
                    private mainServide : MainService,
                    private dialogService: DialogService
    ) {
        this._params.params.subscribe((params : any) => {
            this.dataPayload  =  this.mainServide.deserializeObj(params.payload);
            this.payloadSel = params.payload;
            this.currentPreview = this.dataPayload.material_img;
            console.log(this.dataPayload);
        });
    }

  openImage(imageUrl: string, headerText: string, isMirrored: boolean) {
    if (!imageUrl) return;

    this.ref = this.dialogService.open(VersionImgViewerComponent, {
      header: headerText,
      maximizable: true,
      styleClass: 'dialog-maximized',
      width: '100vw',
      height: '100vh',
      baseZIndex: 10001,
      contentStyle: { "overflow": "auto", "padding": "0" },
      data: [{ url: imageUrl, alt: headerText, isMirrored: isMirrored }]
    });
  }

  currentPreview = "";
  dataPayload : any;
  payloadSel = "";
  matches = [
    { img: 'assets/images/example-mat.png', alt: 'Versión 1' },
    { img: 'assets/images/example-mat.png', alt: 'Versión 2' },
    { img: 'assets/images/example-mat.png', alt: 'Versión 3' },
    { img: 'assets/images/example-mat.png', alt: 'Versión 3' },
    { img: 'assets/images/example-mat.png', alt: 'Versión 3' },
    { img: 'assets/images/example-mat.png', alt: 'Versión 3' },
    { img: 'assets/images/example-mat.png', alt: 'Versión 3' },
    { img: 'assets/images/example-mat.png', alt: 'Versión 3' }
  ];

  selected : any;
  select(item: any) {
    this.selected = item;
     this.currentPreview = item.url;
     console.log("selected item",item);
  }

  versionesList : Array<any> = []

  search = '';
  filteredVersions : Array<any> = []
  
    ngOnInit(): void {
      Swal.close();
      //if(!this.dataPayload.data.version){
        Swal.fire({
          title: 'Cargando...',
          text: 'Esto puede tardar unos segundos',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        this.matService.getVersionsData(this.dataPayload.apiRes.idCampana, this.dataPayload.data.box_id, this.dataPayload.apiRes.idGrupo, this.dataPayload.apiRes.texto).subscribe((x:any)=>{
        
        if(x.message === 'Success'){
         
            this.material_info = x.data

              this.material_info.map((info:any)=>{
                if(info.versiones.length == 0){
                  info.versiones.push({
                    capturas: info.capturas,
                    material: info.nombre,
                    texto:"",
                    url: "assets/images/example-mat.png",
                    version: 1
                  })
                }
              });
              this.material_info.map((item:any) => {
                if (item.versiones && item.versiones.length > 0) {
                  item.versiones.map((v:any) => {
                    this.versionesList.push({
                      id: item.id,
                      nombre: item.nombre,
                      id_grupo: item.id_grupo,
                      id_m: item.id_m,
                      url: v.url,
                      version: v.version,
                      capturas: v.capturas,
                      texto: v.texto,
                      match: v.similarity
                    });
                  });
                }
              });

              const resultado = this.versionesList.sort((a, b) => b.match - a.match);
           
             resultado.sort((a, b) => b.match - a.match);
           
             this.versionesList = resultado.map((item, index) => ({
               ...item,
               rank: index + 1
             }));
             let selectedVersion: any = this.dataPayload.data.version;
             if(this.dataPayload.selected_version){
              selectedVersion = {
                id: this.dataPayload.selected_version.mat.id,
                version: this.dataPayload.selected_version.selected_version.version
              }
             }
            if(selectedVersion){
              this.selected = this.versionesList.filter(x=> 
                x.id == selectedVersion.id 
                && x.version == selectedVersion.version
              )[0];
                   this.currentPreview = this.selected.url;
            }else{
                this.currentPreview = this.versionesList[0].url;
                this.selected = this.versionesList[0];
            }
            console.log("selected", this.selected);
            console.log("versionesList--> ", this.versionesList);

            this.filteredVersions = [...this.versionesList];

           Swal.close();
        }else{
          Swal.close();
          Swal.fire('Error', 'Oops, algo salió mal, por favor intente más tarde', 'error');
        }
      });
    }
  
    

  onRepeat(){
    const data = {
      claw_camp_id:  this.dataPayload.apiRes.idCampana,
      camp_id: this.dataPayload.data.camp_id,
      id_grupo: this.dataPayload.apiRes.idGrupo,
      mat_nombre: this.dataPayload.data.mat_nombre,
      material_img : this.dataPayload.data.material_img,
      mat_id: this.dataPayload.data.mat_id,
      box_id: this.dataPayload.data.box_id,
      version : this.dataPayload.data.version
    };

    let dataStr = this.mainServide.serializeObj(data);
    this.router.navigate(['/material-scan/' + dataStr ]);
  }

  onVersionList(item:any){
     this.router.navigate(['material-version-list/'+ this.dataPayload.apiRes.idCampana  + '/' + this.dataPayload.data.camp_id + '/' + this.dataPayload.data.box_id + '/'+ this.dataPayload.apiRes.idGrupo + '/' +  this.payloadSel ]);
    // this.router.navigate(['/material-version-list/1/2/54']);
  }

  onCancel(item:any){
     this.router.navigate(['/material-list/'+ this.dataPayload.apiRes.idCampana+ '/'+ this.dataPayload.data.box_id ]);
  }

  ruSure() {
  if(this.selected){
    Swal.fire({
    text: this.selected.capturas > 0 ? 'Esta version ya cuenta con una imagen asignada ¿Deseas reemplazarla?' : '¿Está seguro que desea guardar esta captura?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
    customClass: {
      popup: 'swal-font',
      confirmButton: 'swal-confirm-btn',
      cancelButton: 'swal-cancel-btn'
    },
    buttonsStyling: false,
    reverseButtons: true 
  }).then((result) => {
    if (result.isConfirmed) {
    //  this.save();
      this.saveCapture();
    }
  });
  }else{
        Swal.fire({
        icon: 'warning',
        title: 'No hay version seleccionada',
        text: 'Seleccione una version.',
        confirmButtonText: 'Reintentar'
      });
  }

 }


saveCapture() {
  const base64ToBlob = (base64: string, type = 'image/png') => {
    const byteString = atob(base64.split(',')[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }
    return new Blob([intArray], { type });
  };

  const formData = new FormData();
  let listSimilitud = this.versionesList.map((item: any) => ({
    version: item.version,
    match: item.match,
    id_m: item.id_m,
    material: item.id  
  }));

  formData.append('imagenCompletaFile', base64ToBlob(this.matService.capturedImage), 'original.png');
  formData.append('imagenRecorteFile', base64ToBlob(this.matService.croppedImage), 'cropped.png');

  formData.append('idCampana', this.dataPayload.apiRes.idCampana.toString());
  formData.append('idCampanaNest', this.dataPayload.data.camp_id.toString());
  formData.append('idDistribucion', this.dataPayload.data.box_id.toString());
  formData.append('idGrupo', this.dataPayload.apiRes.idGrupo.toString());
  formData.append('idMaterial', this.selected.id.toString());
  formData.append('version', this.selected.version.toString());
  formData.append('posicionVersion', this.selected.rank.toString());
  formData.append('resultadoSimilitud', this.selected.match.toString());
  formData.append('textoImg', this.dataPayload.apiRes.texto.toString());
  formData.append('deviceInfo', this.dataPayload.apiRes.deviceInfo.toString());
  formData.append('listaSimilitud', JSON.stringify(listSimilitud));

     Swal.fire({
          title: 'Guardando...',
          text: 'Esto puede tardar unos segundos',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
      });

  this.matService.saveMaterialImage(formData).subscribe({
    next: (res) => {
      console.log('Subida exitosa', res);
      Swal.close();
      Swal.fire({
        icon: 'success',
        title: '¡Captura completada!',
        text: 'Tu imagen se ha capturado correctamente.',
        confirmButtonText: 'Aceptar'
      }).then(r=>{
          this.router.navigate(['/material-list/'+ this.dataPayload.apiRes.idCampana+ '/'+ this.dataPayload.data.box_id ]);
      });
    },
    error: (err) => {
      console.error('Error al subir', err);
      Swal.close();
      Swal.fire({
        icon: 'error',
        title: 'Error al guardar la captura',
        text: 'Intenta nuevamente más tarde.',
        confirmButtonText: 'Reintentar'
      });
    }
  });
}

     levenshtein(a: string, b: string): number {
      const matrix = Array.from({ length: a.length + 1 }, () => Array(b.length + 1).fill(0));
    
      for (let i = 0; i <= a.length; i++) matrix[i][0] = i;
      for (let j = 0; j <= b.length; j++) matrix[0][j] = j;
    
      for (let i = 1; i <= a.length; i++) {
        for (let j = 1; j <= b.length; j++) {
          if (a[i - 1] === b[j - 1]) {
            matrix[i][j] = matrix[i - 1][j - 1];
          } else {
            matrix[i][j] = Math.min(
              matrix[i - 1][j] + 1,    // eliminación
              matrix[i][j - 1] + 1,    // inserción
              matrix[i - 1][j - 1] + 1 // sustitución
            );
          }
        }
      }
    
      return matrix[a.length][b.length];
    }


    similarity(a: string, b: string): number {
      if (!a || !b) return 0;
      a = a.toLowerCase();
      b = b.toLowerCase();
    
      const distance = this.levenshtein(a, b);
      const maxLen = Math.max(a.length, b.length);
    
      if (maxLen === 0) return 100;
    
      return Math.round(((maxLen - distance) / maxLen) * 100);
    }

    onSearch(value: string) {
      const searchValue = value.toLowerCase().trim();

      if (!searchValue) {
        this.filteredVersions = [...this.versionesList];
        return;
      }

      this.filteredVersions = this.versionesList.filter(item =>
        item.nombre.toLowerCase().includes(searchValue) ||
        item.texto.toLowerCase().includes(searchValue)
      );
    }
}
